import BRANDS from '../public/brands.json'

export default {
  BRANDS,
  LOGS: process.env.VUE_APP_LOGS !== 'false',
  WEB_URL: brandCode => {
    if (process.env.VUE_APP_WEB_URL === 'JSON') {
      return `${BRANDS[brandCode].webUrl}/`
    }
    return process.env.VUE_APP_WEB_URL.replace('[BRAND_CODE]', brandCode)
  },
  API_URL: process.env.VUE_APP_API_URL,
  DATA_URL: process.env.VUE_APP_DATA_URL,
  AUDIO_URL: process.env.VUE_APP_AUDIO_URL,
  MEDIA_URL: process.env.VUE_APP_MEDIA_URL,
  PAYPAL_TOKEN: process.env.VUE_APP_PAYPAL_TOKEN,
  STRIPE_PUBLISHABLE_KEY: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
  GLOBAL_LOGIN_URL: process.env.VUE_APP_GLOBAL_LOGIN_URL,
  GLOBAL_LOGIN_CLIENT_ID: process.env.VUE_APP_GLOBAL_LOGIN_CLIENT_ID
}
